import React, {  useEffect } from 'react';
import { connect } from 'react-redux';
import {useLocation, useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer'
import { checkUser } from '../../redux/actions';
import { Toaster } from 'react-hot-toast';

const AppLayout = ({ children, currentUser,checkUserAction }) => {
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    
    if (localStorage.getItem('userToken') === null || localStorage.getItem('userToken') ==='') {
      navigate('/')
    } else if ( (currentUser === null || currentUser === undefined || Object.keys(currentUser).length === 0)){
      checkUserAction();
    }
  }, []);


  const handleClick = () => {
    if (location.pathname === '/details') 
      navigate('/home');
    else if (location.pathname === '/withdrawal') 
      navigate('/details');
  }

  const linkTo = (link) => {
    navigate('/' + link);
  }
  

  return (
    <main>
    <Footer/>
    <Toaster 
      toastOptions={{
        className: '',
        style: {
          fontSize : '15px'
        },
      }}
      />
      <div className="mdt_wrap">
      
      <div className="gnb_top">
        {location.pathname === '/details' || location.pathname === '/withdrawal'?
        <span className="appBackBtn" onClick={handleClick}>
          <i className="fa-solid fa-arrow-left"></i>
        </span>
        :''
        }
        <img src={process.env.PUBLIC_URL +  "/images/logo.png"} onClick={()=>linkTo('home')} alt="MEDITOC" /></div>
        
          {children}
          
      </div>
    </main>
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser } = authUser;
  return {currentUser}
};

const mapActionToProps = {
  checkUserAction: checkUser,
};

export default connect(mapStateToProps, mapActionToProps)(AppLayout);
